import styled from "styled-components"

export const StyledPage = styled.div`
    & .full-container{
        padding-top: 0;
    }
`
